import React from "react";
import { Link } from "react-router-dom";
import { KNOW_BEFORE } from "@/content/expedition.js";
import { useOrignalUi } from "@/hooks/useOrignalUi.js";

export function KnowBeforePage() {
  const { ui, lang } = useOrignalUi();
  return (
    <main className="og-page" data-testid="page-know">
      <h1>{ui.know.title}</h1>
      <p className="og-lead">{ui.know.subtitle}</p>
      {KNOW_BEFORE.map((row) => (
        <section key={row.id} className={`og-card${row.level === "critical" ? " og-card--amber" : ""}`} data-testid={`know-${row.id}`}>
          {row.level === "critical" ? <p className="og-crit">{ui.lodging.waterStatus}</p> : null}
          <p>{lang === "en" ? row.en : row.fr}</p>
        </section>
      ))}
      <div className="og-toolbar">
        <Link className="og-btn og-btn--primary" to="/preparation">{ui.nav.prep}</Link>
        <Link className="og-btn" to="/hebergement">{ui.nav.lodging}</Link>
      </div>
    </main>
  );
}
